import React, { useState } from 'react';
import { Button, Modal, Row, Col, Tabs, Tab } from 'react-bootstrap'
import CrudTable from '../table/crudtable'
import { expectedAnswerImportConfigurationService, expectedAnswerImportEventService } from '../../_services'
import ExpectedAnswerImportConfigurationForm from './expectedanswerimportconfigurationform.component'
import { useTranslation } from "react-i18next";
import moment from 'moment'
import { SERVER_URL } from '../../config';
import { useDispatch } from 'react-redux'
import { alertActions } from '../../_actions/alert.actions'

function ExpectedAnswerImport() {

	const [selectedConfiguration, setSelectedConfiguration] = useState('')
	const [showConfirmationModal, setShowConfirmationModal] = useState(false)
	const [backdrop, setBackdrop] = useState(false)
	const {t} = useTranslation('common')
	const dispatch = useDispatch()

	const initialState = {
		name: '',
		suggestionList: '',
		type: 'RAMSITE_3GIS',
		frequency: 'DAILY',
		disabled: false,
		params: {
			apiKey: '',
			answerName: '',
			validValues: '',
			templateTaskIds: '',
			templateTaskNames: ''
		}
	}

	const formatParams = function(cell) {
		return <>
			{ Object.keys(cell).filter(key => cell[key]).map(key => {
				return <div key={key}>{key}: {cell[key]}</div>
			})}
		</>
	}

	const formatTriggerNow = function(cell) {
        return <a href="javascript:void(0)" onClick={() => triggerNow(cell)}>Importera nu</a>
    }

    const formatBoolean = function(cell) {
		return cell ? t('crudtable.yes') : t('crudtable.no')
	}

	const formatDate = function(cell) {
		return moment(cell).format('YYYY-MM-DD HH:mm:ss')
	}

    const triggerNow = function(suggestionImportConfigurationId) {
        console.log('triggerNow')
        setSelectedConfiguration(suggestionImportConfigurationId)
		setShowConfirmationModal(true)
    }

    const onHide = () => {
		setShowConfirmationModal(false)
		setBackdrop(false)
    }

    const handleConfirm = () => {
		expectedAnswerImportConfigurationService.triggerNow(selectedConfiguration).then(data => {
			onHide()
			//dispatch(alertActions.success('Importjobbet har startats'))
        })
    }

    const getRowStyle = function(row, rowIndex) {
		return row.success ? {} : {background: '#FFAAAA'}
	}

    const columns = [
	    {
			dataField: 'name',
			text: t('expectedanswerimport.columns.name'),
			sort: true
	    },
	    {
			dataField: 'expectedAnswerListName',
			text: t('expectedanswerimport.columns.expectedanswerlist'),
			sort: true
	    },
	    {
			dataField: 'type',
			text: t('expectedanswerimport.columns.type'),
			sort: true
	    },
	    {
			dataField: 'frequency',
			text: t('expectedanswerimport.columns.frequency'),
			sort: true
	    },
	    {
			dataField: 'params',
			text: t('expectedanswerimport.columns.params'),
			formatter: formatParams,
			filterValue: formatParams
	    },
	    {
			dataField: 'disabled',
			text: t('expectedanswerimport.columns.disabled'),
			formatter: formatBoolean,
			filterValue: formatBoolean
	    },
	    {
			dataField: 'id',
			text: '',
			formatter: formatTriggerNow
	    }
    ]

    const eventColumns = [
	    {
			dataField: 'dateCreated',
			text: t('expectedanswerimport.columns.date'),
			formatter: formatDate,
			sort: true
	    },
	    {
			dataField: 'expectedAnswerImportConfigurationName',
			text: t('expectedanswerimport.columns.configurationname'),
			sort: true
	    },
	    {
			dataField: 'type',
			text: t('expectedanswerimport.columns.type'),
			sort: true
	    },
	    {
			dataField: 'success',
			text: t('expectedanswerimport.columns.success'),
			formatter: formatBoolean,
			sort: true
	    },
	    {
			dataField: 'count',
			text: t('expectedanswerimport.columns.count'),
			sort: true
	    }
    ]

	return (
		<div>
			<h2>
				{t('expectedanswerimport.label')}
            </h2>
            <Tabs>
                <Tab eventKey="configurations" title={t('expectedanswerimport.configurations')} style={{paddingTop: '10px'}}>
		            <CrudTable
				        service={expectedAnswerImportConfigurationService}
				        columns={columns}
				        initialState={initialState}
				        form={<ExpectedAnswerImportConfigurationForm />}
				        sort={{dataField: 'name', order: 'asc'}}
				        modalSize="lg"
				        urlParams={true}
					/>
				</Tab>
                <Tab eventKey="events" title={t('expectedanswerimport.events')} style={{paddingTop: '10px'}}>
                    <CrudTable
				        service={expectedAnswerImportEventService}
				        columns={eventColumns}
				        sort={{dataField: 'dateCreated', order: 'desc'}}
				        modalSize="lg"
				        creatable={false}
				        editable={false}
				        deletable={false}
				        rowStyle={getRowStyle}
					/>
                </Tab>
			</Tabs>
			<Modal
				style={{overflow: 'scroll'}}
				size="md"
				show={showConfirmationModal}
				backdrop={backdrop}
				onShow={() => console.log('onShow')}
				onHide={onHide}
				animation={false}>
				<Modal.Header closeButton>
					<Modal.Title>
						Importera nu
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					Är du säker på att du vill starta ett importjobb för denna konfiguration?
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={onHide}>
						{t('crudtable.cancel')}
					</Button>
					<Button variant="danger" onClick={handleConfirm}>
						{t('crudtable.ok')}
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
    )
}

export default ExpectedAnswerImport;